import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthentifiedPage from "./AuthentifiedPage";
import BackButton from "../components/BackButton";
import { Indicateur } from "../types/Indicateur";
import { useAuth } from "../context/AuthContext";
import { indicateurService } from "../services/IndicateurService";
import { rapportGenereService } from "../services/RapportGenereService";
import LocalitySelector from "../components/LocalitySelector";
import IndicateurTableContainer from "../components/IndicateurTableContainer";
import IndicateurChartContainer from "../components/IndicateurChartContainer";


const RapportFromModelePage: React.FC = () => {
  const location = useLocation();
  const { modele } = location.state || {};

  const [indicateurs, setIndicateurs] = useState<Indicateur[]>([]);
  const [showRegionPopup, setShowRegionPopup] = useState(false);
  const [selectedLocality, setSelectedLocality] = useState<{ idIle?: number; idRegion?: number; idCommune?: number; idLocalite?: number } | null>(null);

  const [indicatorData, setIndicatorData] = useState<Record<number, { meta: any; rows: Record<string, any>[] }>>({});
  const [generating, setGenerating] = useState<boolean>(false);

  const { api } = useAuth();

  useEffect(() => {
    if (!modele) return;

    const resetData = modele.indicateurs.map((ind: any) => {
      const toReturn ={
        id:ind.idIndicateur,
        nom:ind.nom
      };

      return toReturn
    });

    setIndicateurs(resetData);
  }, [modele]);

  useEffect(() => {
      const loadIndicatorData = async () => {
        try{
          const result = await indicateurService.loadMultiIdDatas(api,indicateurs);
          setIndicatorData(result);

        }catch(e){
          return;
        }
      };
  
      loadIndicatorData();
  }, [api, indicateurs]);

  const handleGenererRapport = async () => {
      if (!modele || !api) return;

      setGenerating(true);

      try {
        const created = await rapportGenereService.createRapportGenere(
          api,
          modele.idRapport,
          selectedLocality
        );

        if (created) {
          alert("Rapport généré avec succès.");
        } else {
          alert("Échec lors de la demande de génération du rapport.");
        }
      } catch (e) {
        console.error(e);
        alert("Erreur lors de la génération du rapport.");
      } finally {
        setGenerating(false);
        setShowRegionPopup(false);
      }
  };

  if (!modele) {
    return (
      <AuthentifiedPage>
        <div style={{ padding: 40 }}>Aucun modèle reçu.</div>
      </AuthentifiedPage>
    );
  }

  return (
    <AuthentifiedPage>
      <div style={{ maxWidth: 900, margin: "20px auto", fontFamily: "Arial" }}>
        <BackButton text="Retour" />
        <h3>
          Génération de rapport : <span style={{ color: "green" }}>{modele.name}</span>
        </h3>
        {modele.description && <p style={{ marginBottom: 20 }}>{modele.description}</p>}

        <button
          className="btn-import"
          onClick={() => setShowRegionPopup(true)}
          style={{ marginBottom: 20 }}
        >
          <i className="bi bi-file-earmark-text"></i> Générer un rapport
        </button>

        {showRegionPopup && (
          <div style={{
            position: "fixed",
            top: 0, left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000
          }}>
            <div style={{ background: "white", padding: 20, borderRadius: 8, width: "100%", maxWidth: "600px" }}>
              <h5>Choisir une localité</h5>
              <LocalitySelector value={selectedLocality} onChange={setSelectedLocality} />
              <button
                onClick={handleGenererRapport}
                disabled={!selectedLocality || (!selectedLocality.idIle && !selectedLocality.idRegion && !selectedLocality.idCommune && !selectedLocality.idLocalite)}
                style={{ marginTop: 20, minWidth:"100%", padding: 8, opacity: (!selectedLocality || (!selectedLocality.idIle && !selectedLocality.idRegion && !selectedLocality.idCommune && !selectedLocality.idLocalite)) ? 0.5 : 1, cursor: (!selectedLocality || (!selectedLocality.idIle && !selectedLocality.idRegion && !selectedLocality.idCommune && !selectedLocality.idLocalite)) ? 'not-allowed' : 'pointer' }}
                className="btn-import"
              >
                {generating ? "Génération en cours..." : "Générer"}
              </button>
              <button
                onClick={() => setShowRegionPopup(false)}
                style={{ marginTop: 10, width: "100%", padding: 8, borderRadius: 25 }}
                className="btn btn-secondary"
              >
                Annuler
              </button>
            </div>
          </div>
        )}

        <hr />

        {indicateurs.length>0 && (
          <div>
            <h2 style={{color:"black", width:"fit-content", margin:"2vh auto", marginTop:"5vh", paddingBottom:"1vh", fontWeight:"bold", borderBottom:"1px solid rgba(25,25,25,.2)"}}>Aperçu global</h2>
            <div style={{marginBottom: "5vh"}}>
              <h4 style={{ textAlign:"center" }}>Tableau des indicateurs</h4>
              <IndicateurTableContainer indicatorData={indicatorData}/>
            </div>
            <div style={{marginBottom: "5vh"}}>
              <h4 style={{ margin: "5vh 0" }}>Répartition</h4>
              <IndicateurChartContainer indicatorData={indicatorData} chartType="pie"/>
            </div>

            <div style={{marginBottom: "5vh"}}>
              <h4 style={{ marginTop: "5vh 0" }}>Graphique linéaire</h4>
              <IndicateurChartContainer indicatorData={indicatorData} chartType="area"/>
            </div>
          </div>
        )}
      </div>
    </AuthentifiedPage>
  );
};

export default RapportFromModelePage;